import { type PlacementId } from '@schibsted-nmp/advertising-shared';

export function addAdCloseButton(placementId: PlacementId) {
  const slotEl = document.getElementById(placementId);
  if (!slotEl) return;

  if (slotEl.querySelector('[data-ad-close-button="true"]')) return;

  slotEl.setAttribute('role', 'region');
  slotEl.setAttribute('aria-label', 'Advertisement');

  const closeBtn = document.createElement('button');
  closeBtn.type = 'button';
  closeBtn.setAttribute('data-ad-close-button', 'true');
  closeBtn.setAttribute('aria-label', 'Close advertisement');
  closeBtn.textContent = 'Close ad';

  Object.assign(closeBtn.style, {
    position: 'absolute',
    top: '8px',
    left: '8px',
    zIndex: '2',
    background: 'transparent',
    color: '#000',
    border: 'none',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: '14px'
  });

  const closeAd = () => {
    closeBtn.blur();
    document.body.focus();

    slotEl.setAttribute('aria-hidden', 'true');
    slotEl.style.display = 'none';
  };

  closeBtn.addEventListener('click', closeAd);

  slotEl.prepend(closeBtn);
}
